//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_JWT_LOGIN = "/auth/login"
export const POST_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/users"
export const ADD_NEW_USER = "/users"
export const UPDATE_USER = "/users"
export const DELETE_USER = "/users"
export const UPDATE_SEASON_STATUS = "/users/update-status"

//ROLES
export const GET_ROLES = "/roles"
export const GET_ROLE_DETAIL = "/roles"
export const ADD_NEW_ROLE = "/roles"
export const UPDATE_ROLE = "/roles"

export const GET_EARNING_DATA = "/earning-charts-data"

//BLACKLISTS
export const GET_BLACKLISTS = "/blacklists"
export const GET_BLACKLIST_DETAIL = "/blacklists"
export const ADD_NEW_BLACKLIST = "/blacklists"
export const UPDATE_BLACKLIST = "/blacklists"


//carpark
export const CARPARK = "/carparks";
export const CARPARK_OCCUPANCY_RATE = "/carparks-occupancy";
export const LOTS_SOLD_URL = "/lots-sold";

//carpark
export const SEASON_PASS = "/season-passes"

//guest
export const GUESTS = "/guestentry"
export const GUESTS_ACCESS_STATUS = "/guestentry/update-status"
export const GUEST_COMPLIMENTARY_GRANT = "/complimentary/grant";

//admins
export const ADMINS = "/admin/users"

//Audits
export const AUDITS = "/audits"

//Bills
export const BILLS = "/bills"

//Settings
export const UPDATE_SYSTEM_SETTING = "/settings"
export const GET_SYSTEM_SETTING = "/settings"

//Manage Settings
export const GET_MANAGE_ADMIN = "/manageadmin"

//Carparks
export const CARPARK_TICKETS = "/carpark-tickets";

//Speical date
export const ADD_SPECIAL_DATES = "/special"
export const GET_SPECIAL_DATES = "/special"
export const DELETE_SPECIAL_DATES = "/special"
export const UPDATE_SPECIAL_DATES = "/special"

//Dashboard
export const DASHBOARD = "/dashboard"
